export const hasItems = (array: any[]): boolean => array && array.length !== 0;
